const $axeptio = document.getElementById('axeptio_app');
const axeptio_id = $axeptio.getAttribute('data-axeptio-id');
// var hotjar_id = $axeptio.getAttribute('data-hotjar-id');
// var aw_id = $axeptio.getAttribute('data-aw-id'); //AW-XXXXXXX
// var gtm_id = $axeptio.getAttribute('data-gtm-id');
// var bing_id = $axeptio.getAttribute('data-bing-id');

const launchAxeptio = function () {
  window.axeptioSettings = {
    clientId: axeptio_id,
    cookiesVersion: Shopify.locale,
    googleConsentMode: {
      default: {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500,
      },
    },
  };

  (function (d, s) {
    var t = d.getElementsByTagName(s)[0],
      e = d.createElement(s);
    e.async = true;
    e.src = '//static.axept.io/sdk.js';
    t.parentNode.insertBefore(e, t);
  })(document, 'script');
};

// // HOTJAR
// var launchHJ = function (h, o, t, j, a, r) {
//   h.hj =
//     h.hj ||
//     function () {
//       (h.hj.q = h.hj.q || []).push(arguments);
//     };
//   h._hjSettings = { hjid: hotjar_id, hjsv: 6 };
//   a = o.getElementsByTagName('head')[0];
//   r = o.createElement('script');
//   r.async = 1;
//   r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
//   a.appendChild(r);
// };

// // BING
// var launchBI = function (w, d, t, r, u) {
//   var f, n, i;
//   (w[u] = w[u] || []),
//     (f = function () {
//       var o = { ti: bing_id };
//       (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
//     }),
//     (n = d.createElement(t)),
//     (n.src = r),
//     (n.async = 1),
//     (n.onload = n.onreadystatechange =
//       function () {
//         var s = this.readyState;
//         (s && s !== 'loaded' && s !== 'complete') ||
//           (f(), (n.onload = n.onreadystatechange = null));
//       }),
//     (i = d.getElementsByTagName(t)[0]),
//     i.parentNode.insertBefore(n, i);
// };

// // GoogleTagManager
// var launchGTM = function (w, d, s, l, i) {
//   w[l] = w[l] || [];
//   w[l].push({
//     'gtm.start': new Date().getTime(),
//     event: 'gtm.js',
//   });
//   var f = d.getElementsByTagName(s)[0],
//     j = d.createElement(s),
//     dl = l != 'dataLayer' ? '&l=' + l : '';
//   j.async = true;
//   j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
//   f.parentNode.insertBefore(j, f);
// };

// var f = document.getElementsByTagName('script')[0],
//   j = document.createElement('script');
// j.async = true;
// j.src = 'https://www.googletagmanager.com/gtag/js?id=' + aw_id;
// f.parentNode.insertBefore(j, f);

// window.dataLayer = window.dataLayer || [];

// function gtag() {
//   dataLayer.push(arguments);
// }
// gtag('js', new Date());
// gtag('config', aw_id);
// gtag('consent', 'default', {
//   ad_storage: 'denied',
// });

// var launchGtag = function (w, d, s, l, i) {
//   gtag('consent', 'update', {
//     ad_storage: 'granted',
//   });
// };

// var refuseGtag = function (w, d, s, l, i) {
//   gtag('consent', 'update', {
//     ad_storage: 'denied',
//   });
// };

// // KLAVIYO
// var launchKY = function () {
//   //  EN ATTENTE DE REPONSE DE KLAVIYO
//   var o = document;
//   a = o.getElementsByTagName('body')[0];
//   r = o.createElement('script');
//   r.async = 1;
//   r.src = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
//   a.appendChild(r);
// };

// // KWANKO
// var launchKW = function () {
//   var o = document;
//   a = o.getElementsByTagName('body')[0];
//   r = o.createElement('script');
//   r.async = 1;
//   r.src = 'https://cdn.shopify.com/s/files/1/0014/3789/2695/files/p69331uni.js';
//   a.appendChild(r);
// };
// // modify cart.template and remove script

// //ABTasty
// var launchABTasty = function () {
//   var o = document;
//   a = o.getElementsByTagName('body')[0];
//   r = o.createElement('script');
//   r.async = 1;
//   r.src = 'https://try.abtasty.com/bf63aeb8c4764d0785d88a653625364b.js';
//   a.appendChild(r);
// };

// void 0 === window._axcb && (window._axcb = []);
// window._axcb.push(function (axeptio) {
//   axeptio.on('cookies:complete', function (choices) {
//     const widgetElement = document.querySelector('#axeptio_overlay');

//     if (widgetElement) {
//       widgetElement.style.display = 'none';
//     }

//     if (choices.googletagmanager) {
//       if (gtm_id != null) {
//         launchGTM(window, document, 'script', 'dataLayer', gtm_id);
//       }
//       launchGtag(window, document, 'script', 'dataLayer', aw_id);
//     } else {
//       refuseGtag(window, document, 'script', 'dataLayer', aw_id);
//     }
//     if (choices.shopify) {
//       window.Shopify.customerPrivacy.setTrackingConsent(true, function () {
//         console.log('true');
//       });
//     }
//     if (choices.static_hotjar) {
//       launchHJ(
//         window,
//         document,
//         'https://static.hotjar.com/c/hotjar-',
//         '.js?sv='
//       );
//     }
//     if (choices.__kla_id) {
//       launchKY();
//     }
//     if (choices.ABtasty) {
//       launchABTasty();
//     }
//     if (choices.Bing) {
//       launchBI(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
//     }
//     if (choices.static_kwanko) {
//       launchKW();
//     }
//     if (choices.mcanism) {
//       console.log('mcanism');
//     }
//     if (choices.Google_Ads) {
//       console.log('Google_Ads');
//     }
//   });
// });
// window.Shopify.loadFeatures(
//   [
//     {
//       name: 'consent-tracking-api',
//       version: '0.1',
//     },
//   ],
//   (error) => {
//     if (error) {
//       throw error; // if you want to raise
//     }
//     launchAxeptio(); // or whatever method your banner uses to initialize
//   }
// );
launchAxeptio();
